export default function ECATBaseController(
  userService
) {
  const vm = this;

  console.log('app.components.advisory.ecat.ecatBaseController created');

  /** ********************************
   * Public API
   */

  vm.initPermissions = _initPermissions;

  /** ********************************
   * Private Functions
   */

  function _initPermissions() {
    return userService.getUserPermissionSet('ecat').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}
